import { render, staticRenderFns } from "./leftBlock.vue?vue&type=template&id=5a18224a&"
import script from "./leftBlock.vue?vue&type=script&lang=js&"
export * from "./leftBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports